import AdminSidebar from 'admin/sidebar/AdminSidebar';
import React, { useEffect, useState } from 'react';
import './app.css';
import ButtonDahbaord from 'components/ButtonDahbaord/ButtonDahbaord';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { CircularProgress } from '@mui/material';
import moment from 'moment';

const RECIPIENTS = [
  { value: 'both', label: 'Customers & Sellers' },
  { value: 'customer', label: 'Customers' },
  { value: 'seller', label: 'Sellers' },
];

const MESSAGE_LIMIT = 180;
const DEFAULT_MESSAGE = 'This notification is just for testing';

const Sendnotifications = () => {
  const [recipient, setRecipient] = useState('');
  const [message, setMessage] = useState('');
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [now, setNow] = useState(moment());

  useEffect(() => {
    window.scrollTo(0, 0);
    const timer = setInterval(() => setNow(moment()), 30000);
    return () => clearInterval(timer);
  }, []);

  const validate = () => {
    const newErrors = {};
    if (!recipient) newErrors.recipient = 'Choose who should receive this notification';
    if (!title.trim()) newErrors.title = 'Add a title so people know what it is about';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSendNotification = () => {
    if (!validate()) return;
    SubmitNotification();
  };

  const SubmitNotification = async () => {
    setLoading(true);
    try {
      const payload = {
        title: title,
        body: message || DEFAULT_MESSAGE,
      };

      const token = localStorage.getItem('accessTokenAdmin');
      let apiUrl = `https://production.washta.com/api/admin/sendNotification?sendTo=${recipient}`;
      await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      toast.success('Notification sent successfully');
      setRecipient('');
      setMessage('');
      setTitle('');
      setErrors({});
    } catch (error) {
      console.error('Error sending notification:', error);
      toast.error('Could not send notification');
    } finally {
      setLoading(false);
    }
  };

  const recipientLabel = RECIPIENTS.find((r) => r.value === recipient)?.label;
  const isOverLimit = message.length > MESSAGE_LIMIT;

  return (
    <div className="sn-page">
      <div className="div-sidebar">
        <AdminSidebar />
      </div>
      <div className="div-Dashbaord" style={{padding:'28px 32px 60px',background:'white'}}>
        <div className="sn-content">
          <div className="sn-header">
            <h1 className="sap-title">Send notification</h1>
            <p className='ws-view-sub'>Push a message straight to customers, sellers, or both.</p>
          </div>

          <div className="sn-builder">
            {/* -------- Form card -------- */}
            <div className="sn-card">
              <h3 className="sn-card-title">Compose notification</h3>
              <p className="ws-view-sub">Pick an audience, then write a short, clear message.</p>

              <div className="sn-field">
                <label>Send to</label>
                <div className="sn-segmented">
                  {RECIPIENTS.map((r) => (
                    <button
                      type="button"
                      key={r.value}
                      className={`sn-segment ${recipient === r.value ? 'sn-segment-active' : ''}`}
                      onClick={() => setRecipient(r.value)}
                    >
                      {r.label}
                    </button>
                  ))}
                </div>
                {errors.recipient && <p className="sn-error">{errors.recipient}</p>}
              </div>

              <div className="sn-field">
                <label>Title</label>
                <input
                  type="text"
                  placeholder="e.g. Weekend discount is live"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  maxLength={60}
                />
                {errors.title && <p className="sn-error">{errors.title}</p>}
              </div>

              <div className="sn-field">
                <label>Message</label>
                <textarea
                  placeholder={DEFAULT_MESSAGE}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  rows="6"
                />
                <div className="sn-field-footer">
                  <span className="sn-hint">Leave blank to send the default test message.</span>
                  <span className={`sn-count ${isOverLimit ? 'sn-count-warn' : ''}`}>
                    {message.length}/{MESSAGE_LIMIT}
                  </span>
                </div>
              </div>

              <div className="sn-actions">
                <ButtonDahbaord
                  handleclick={handleSendNotification}
                  textButton={
                    loading ? (
                      <CircularProgress size={20} style={{ color: 'white' }} />
                    ) : (
                      'Send notification'
                    )
                  }
                  height={42}
                  width={'220px'}
                  background="#6C5CE7"
                  disabled={loading}
                />
              </div>
            </div>

            {/* -------- Live preview -------- */}
            <div className="sn-preview-slot">
              <p className="sn-preview-label">Preview</p>
              <div className="sn-phone">
                <div className="sn-phone-time">{now.format('h:mm')}</div>
                <div className="sn-notification">
                  <div className="sn-notification-icon">W</div>
                  <div className="sn-notification-body">
                    <div className="sn-notification-top">
                      <span className="sn-notification-app">Washta</span>
                      <span className="sn-notification-when">now</span>
                    </div>
                    <div className="sn-notification-title">{title || 'Notification title'}</div>
                    <div className="sn-notification-message">{message || DEFAULT_MESSAGE}</div>
                  </div>
                </div>
                <div className="sn-preview-audience">
                  Sending to <strong>{recipientLabel || 'no one selected yet'}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer />
      </div>
    </div>
  );
};

export default Sendnotifications;